import { Injectable } from '@angular/core';

import { Statement } from '@models';
import { CrudService, HttpService } from '@services';

@Injectable({ providedIn: 'root' })
export class StatementService extends CrudService<Statement> {
  constructor(http: HttpService) {
    super('statement', http);
  }

  public async getStatementById(statementId: string): Promise<Statement> {
    const url = `${this.url}/${statementId}`;
    const response = await this.http.get<Statement>(url);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // override methods which are not available for this service
  override create(data: Partial<Statement>): Promise<Statement> {
    throw new Error('Method not available.');
  }
  override get(): Promise<Statement[]> {
    throw new Error('Method not available.');
  }

  override update(data: Partial<Statement>): Promise<Statement> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
